import React, { Component } from 'react';
import '../App.css';
import {withRouter} from 'react-router-dom'
import { Grid, Row, Col, PageHeader, Button, FormGroup,
  ControlLabel, FormControl, Form, Checkbox, Image } from 'react-bootstrap';
import {isRealUser, auth} from "../App";
import Crummy from "../Components/Crummy";

class Settings extends Component {

  constructor(props) {
    super(props);
    this.updateSettings = this.updateSettings.bind(this);
  }

  updateSettings(event) {
    event.preventDefault();
    console.log("updateSettings");

    console.log(this.email.value);
    console.log(this.displayName.value);

  }

  breadcumb() {
    return (
      <Crummy
        paths={
          [
            {'name': 'Home', 'path': '/'},
          ]
        } page={'Settings'}/>
    );
  }

  settingsLoggedIn() {

    return (
      <Grid>
        {this.breadcumb()}
        <Row>
          <PageHeader>
            Settings
          </PageHeader>
        </Row>


        <Row>

          <Form horizontal onSubmit={this.updateSettings}>

            <FormGroup>
              <Col componentClass={ControlLabel} sm={2}>
                Profile Image
              </Col>
              <Col sm={1}>
                <div width={25}>
                  <Image src="/images/zoetrovelogo@0,25x.png" circle responsive/>
                </div>
              </Col>
            </FormGroup>

            <FormGroup controlId="formHorizontalEmail">
              <Col componentClass={ControlLabel} sm={2}>
                Email
              </Col>
              <Col sm={6}>
                <FormControl type="email" placeholder="Email" defaultValue={auth.currentUser.email} inputRef={(email) => this.email = email}/>
              </Col>
            </FormGroup>

            <FormGroup controlId="formHorizontalDisplayName">
              <Col componentClass={ControlLabel} sm={2}>
                Display Name
              </Col>
              <Col sm={6}>
                <FormControl type="text" placeholder="Display Name" defaultValue={auth.currentUser.displayName} inputRef={(displayName) => this.displayName = displayName}/>
              </Col>
            </FormGroup>

            <FormGroup controlId="artistCheckBox">
              <Col smOffset={2} sm={6}>
                <Checkbox>I am an artist</Checkbox>
              </Col>
            </FormGroup>

            <FormGroup>
              <Col smOffset={2} sm={6}>
                <Button type="submit">
                  Update Settings
                </Button>
              </Col>
            </FormGroup>

          </Form>
        </Row>
      </Grid>
    );
  }

  settingsLoggedOut() {
    return (
      <Grid>
        <Row>
          <PageHeader>Settings</PageHeader>
        </Row>
        <row>
          logged out
        </row>
      </Grid>
    );
  }


  render() {
    const settingsLoggedIn = this.settingsLoggedIn();
    const settingsLoggedOut =  this.settingsLoggedOut();

    return (
      <div>
          {(isRealUser())
            ? <div>{settingsLoggedIn}</div>
            : <div>{settingsLoggedOut}</div>
          }
      </div>
    );
  }
}

export default withRouter(Settings);



// WEBPACK FOOTER //
// ./src/pages/Settings.jsx